import { Row, Col } from 'react-bootstrap';
import ArticleSection from '../../../Components/articleSection/ArticleSection';
import './gerdSymtoms.css';

const symtoms = [
  'nausea',
  'pain when',
  'swallowing',
  'difficulty swallowing',
  'chronic cough',
  'a hoarse voice',
  'bad breath'
];

function GerdSymtoms() {
  return (
    <section className="gerdSymtoms">
      <Row>
        <Col md={9}>
          <ArticleSection
            heading="GERD symptoms"
            desc="The main symptom of GERD is acid reflux. Acid reflux can cause an uncomfortable burning feeling in your chest, which can move up into your neck and throat. This feeling is often known as heartburn. If you have acid reflux, you might develop a sour or bitter taste at the back of your mouth. It might also cause the regurgitation of food or liquid from your stomach into your mouth. Some other symptoms of GERD include:"
            points={symtoms}
          />
        </Col>
        <Col md={3}>
          <div className="add">
            <h3>Ad Space</h3>
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default GerdSymtoms;
